//작성중인 패키지 리스트 확인하는 페이지
import { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { Spin, Modal, Layout, Tabs } from 'antd'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import MypageNav from '../../components/navigation/MypageNav'
import PkgItem from '../../components/package/Pkgitem'
import Headline from '../../components/Headline'
import { NoDataIcon } from '../../components/CustomIcon'
import { PackStatus } from '../../types'
import PackageWrapperWithStatus from '../package/PackageWrapperWithStatus'
import { useGetMyPackage } from '../../hooks/reactQuery/useUserInfo'
import { useUserWithRedirect } from '../../hooks/user/useUserWithRedirect'
type PackStatusWithAll = 'all' | PackStatus

type PkgsGroupItem = {
  title: {
    id: string
    text: string
  }
  key: PackStatusWithAll
}
const pkgsGroup: PkgsGroupItem[] = [
  {
    title: {
      id: 'Mypage.pkg.tab.all',
      text: 'All',
    },
    key: 'all',
  },
  {
    title: {
      id: 'Mypage.pkg.tab.approved',
      text: 'Released',
    },
    key: 'approved',
  },
  {
    title: {
      id: 'Mypage.pkg.tab.creating',
      text: 'Creating',
    },
    key: 'creating',
  },
  {
    title: {
      id: 'Mypage.pkg.tab.editing',
      text: 'Editing',
    },
    key: 'editing',
  },
  {
    title: {
      id: 'Mypage.pkg.tab.underReview',
      text: 'Pending',
    },
    key: 'under review',
  },
  {
    title: {
      id: 'Mypage.pkg.tab.unapproved',
      text: 'Rejected',
    },
    key: 'unapproved',
  },
]

const NoPkgView = () => (
  <div style={{ width: '80%', textAlign: 'center', margin: '40px  auto' }}>
    <NoDataIcon style={{ width: 100, margin: 'auto' }} />
    <p
      style={{
        margin: 20,
        fontSize: 16,
        fontFamily: 'NotoSans',
        color: '#adadad',
      }}
    >
      No Pack
    </p>
  </div>
)

export default function MyPackage() {
  // const { packageList } = useSelector(selectMyPackages)
  const user = useUserWithRedirect()
  const history = useHistory()
  const { data: packageList, isLoading } = useGetMyPackage({
    userOid: user?.objectId,
    sessionToken: user?.sessionToken,
  })
  const [selectedTab, setSelectedTab] = useState<'all' | PackStatus>('all')
  const st = useLocation()
  const params = new URLSearchParams(st.search)
  const filter = params.get('filter') ? params.get('filter') : 'all'
  const [selectedPackageId, setSelectedPackageId] = useState<null | string>(
    null,
  )
  const filterPackageList = packageList
    ? filter === 'all'
      ? packageList
      : packageList.filter((packageInfo) => packageInfo.status === filter)
    : []

  return (
    <Layout style={{ background: '#fff' }}>
      <MypageNav selectedKey={'mypackage'} />
      <Layout.Content style={{ margin: 20 }}>
        <Headline
          id="MyPackage.headline"
          defaultMessage="My Pack"
          isNoLine={true}
        />
        <Spin spinning={!packageList} tip="Loading...">
          <Tabs
            onChange={(key) => history.push(`?filter=${key}`)}
            type="card"
            className="mypackage-tab"
            tabBarStyle={{ marginBottom: 40 }}
            defaultActiveKey={filter as string}
          >
            {pkgsGroup.map((data) => (
              <Tabs.TabPane
                tab={
                  <div style={{ width: 95, textAlign: 'center' }}>
                    <FormattedMessage
                      id={data.title.id}
                      defaultMessage={data.title.text}
                    />
                  </div>
                }
                key={data.key}
              >
                <div
                  style={{
                    margin: '0px 15px 50px 15px',
                    display: 'flex',
                    flexFlow: 'row wrap',
                  }}
                >
                  {filterPackageList.length === 0 ? (
                    <NoPkgView />
                  ) : (
                    filterPackageList.map((pkg, index) => (
                      <PkgItem
                        key={pkg.objectId}
                        packageInfo={pkg}
                        setSelectedPackageId={setSelectedPackageId}
                      />
                    ))
                  )}
                </div>
              </Tabs.TabPane>
            ))}
          </Tabs>
          {selectedPackageId && (
            <Modal
              visible={selectedPackageId ? true : false}
              onOk={() => setSelectedPackageId(null)}
              onCancel={() => setSelectedPackageId(null)}
              footer={null}
              width={862}
              className="progress-guide-modal"
              bodyStyle={{
                padding: '16px  32px',
                lineHeight: 1.79,
                letterSpacing: -0.36,
                color: '#828282',
                fontSize: 14,
              }}
            >
              {selectedPackageId && (
                <PackageWrapperWithStatus packageId={selectedPackageId} />
              )}
            </Modal>
          )}
          {/* <Modal
            visible={this.state.visible}
            onOk={() => this.setState({ visible: false })}
            onCancel={() => this.setState({ visible: false })}
            footer={null}
            width={862}
            className="progress-guide-modal"
            bodyStyle={{
              margin: '0px 40px 33px 40px',
              lineHeight: 1.79,
              letterSpacing: -0.36,
              color: '#828282',
              fontSize: 14,
            }}
          >
            <PkgAndStickerInfo
              pkgId={this.state.selectedPkgId}
              needStickerInspectData={false}
              page="myPackage"
            />
          </Modal> */}
        </Spin>
      </Layout.Content>
    </Layout>
  )
}
